import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useRef, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import cx from 'classnames';
import ModalDialog from './modal-dialog';
import Progress from './react-ui/progress.jsx';
import ah from '../../utils/ajax-helper';
import { forgotPasswordAPI } from '../../api/userAPI';
import Input from '../ui/input';
var gt = i18n.getFixedT(null, 'app');
var lt = i18n.getFixedT(null, 'login');
var et = i18n.getFixedT(null, 'errors');
var imageCodeReloadInterval = 60000;
var ACTIVE_MODAL = {
  LOGIN: 'login',
  FORGOT_PASSWORD: 'forgotPassword',
  FORGOT_PASSWORD_SUCCESS: 'forgotPasswordSuccess'
};

var LoginDialog = function LoginDialog(props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot;

  var dispatch = useDispatch();

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      imageCode = _useState2[0],
      setImageCode = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var _useState5 = useState(ACTIVE_MODAL.LOGIN),
      _useState6 = _slicedToArray(_useState5, 2),
      activeModal = _useState6[0],
      setActiveModal = _useState6[1];

  var _useState7 = useState({
    email: '',
    userName: ''
  }),
      _useState8 = _slicedToArray(_useState7, 2),
      forgotPasswordFormData = _useState8[0],
      setForgotPasswordFormData = _useState8[1];

  var xhr = useRef();
  var loginParam1 = useRef();
  var loginParam2 = useRef();
  var imageCodeRef = useRef();
  var form = useRef();
  var lastImageCodeTime = useRef(-1);
  var intervalImage = useRef();
  var id = props.id,
      onClose = props.onClose;

  var logon = function logon() {
    if (!loginParam1.current.value || !loginParam2.current.value || imageCodeRef.current && !imageCodeRef.current.value) {
      if (!loginParam1.current.value) setError(lt('txt-login-account'));else if (!loginParam2.current.value) setError(lt('txt-login-password'));else if (imageCodeRef.current && !imageCodeRef.current.value) setError(lt('txt-image-code'));
      return;
    }

    Progress.startSpin();
    var userData = {
      loginParam1: loginParam1.current.value,
      loginParam2: loginParam2.current.value,
      imageCode: imageCodeRef.current.value
    };
    ah.post("".concat(contextRoot, "/validate/account"), JSON.stringify(userData)).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      var validatedResult = result.data.value;

      if (validatedResult.status === 'fail') {
        loadImageCode();
        return setError(et(validatedResult.validatedCode));
      }

      return form.current.submit();
    }).catch(function (error) {
      console.log(error);
    });
  };

  var sendForgotPassword = function sendForgotPassword() {
    console.log('sendForgotPassword', forgotPasswordFormData);
    var email = forgotPasswordFormData.email;
    var userName = forgotPasswordFormData.userName;

    if (!email || !userName) {
      if (!email || !userName) setError(et('txt-fill-out-required'));
      return;
    }

    Progress.startSpin();
    forgotPasswordAPI(contextRoot, false, email, userName).then(function () {
      setActiveModal(ACTIVE_MODAL.FORGOT_PASSWORD_SUCCESS);
      setError('');
    }).catch(function (err) {
      setError(err.message);
    });
  };

  var handleKeyDown = function handleKeyDown(e) {
    setError('');

    if (e.keyCode === 13) {
      logon(e);
    }
  };

  var handleClose = function handleClose() {
    onClose();
  };

  var handleConfirm = function handleConfirm() {
    if (activeModal === ACTIVE_MODAL.LOGIN) {
      logon();
    }

    if (activeModal === ACTIVE_MODAL.FORGOT_PASSWORD) {
      sendForgotPassword();
    }
  };

  var loadImageCode = function loadImageCode() {
    xhr.current = new XMLHttpRequest();

    xhr.current.onload = function () {
      var reader = new FileReader();

      reader.onloadend = function (e) {
        setImageCode(e.target.result);
        lastImageCodeTime.current = new Date().getTime();
      };

      if (xhr.current.response && xhr.current.response.size && xhr.current.response.size > 0) reader.readAsDataURL(xhr.current.response);
    };

    xhr.current.open('GET', "".concat(contextRoot, "/code/image?t=").concat(new Date().getTime()));
    xhr.current.responseType = 'blob';
    xhr.current.send();
  };

  var handleSwitchModal = function handleSwitchModal() {
    if (activeModal === ACTIVE_MODAL.LOGIN) {
      setActiveModal(ACTIVE_MODAL.FORGOT_PASSWORD);
    } else {
      setActiveModal(ACTIVE_MODAL.LOGIN);
    }
  };

  useEffect(function () {
    loadImageCode();
    intervalImage.current = setInterval(function () {
      var now = new Date().getTime();
      if (lastImageCodeTime.current != -1 && now - lastImageCodeTime.current >= imageCodeReloadInterval) loadImageCode();
    }, 1000);
    return function () {
      clearInterval(intervalImage.current);
    };
  }, []);
  var actions = {};

  _.set(actions, 'switch', {
    text: activeModal === ACTIVE_MODAL.LOGIN ? gt('login.lbl-forgot-password') : gt('login.lbl-return-login'),
    handler: handleSwitchModal
  });

  _.set(actions, 'cancel', {
    text: gt('global.lbl-answer-cancel'),
    handler: handleClose
  });

  if (activeModal !== ACTIVE_MODAL.FORGOT_PASSWORD_SUCCESS) {
    _.set(actions, 'confirm', {
      text: activeModal === ACTIVE_MODAL.LOGIN ? gt('login.lbl-login') : gt('login.lbl-send'),
      className: 'button-success',
      handler: handleConfirm
    });
  }

  return /*#__PURE__*/React.createElement(ModalDialog, {
    id: id,
    title: activeModal === 'login' ? gt('login.user-login') : gt('login.user-forgot-password'),
    global: true,
    info: error,
    infoClassName: cx({
      'c-error': error
    }),
    actions: actions,
    closeAction: "cancel"
  }, /*#__PURE__*/React.createElement("div", {
    className: "login-form",
    style: {
      width: '100%'
    }
  }, activeModal === ACTIVE_MODAL.FORGOT_PASSWORD && /*#__PURE__*/React.createElement("div", {
    className: "forgot-password"
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '0 0 1rem 0'
    }
  }, gt('login.forgot-password-description')), /*#__PURE__*/React.createElement("div", {
    className: "input-block"
  }, /*#__PURE__*/React.createElement("p", null, gt('login.lbl-forgot-password-email')), /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: '20px'
    }
  }, /*#__PURE__*/React.createElement(Input, {
    id: "forgotPasswordEmail",
    name: "forgotPasswordEmail",
    type: "email",
    placeholder: gt('login.lbl-forgot-password-email'),
    validate: {
      required: true,
      pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      t: function t(code) {
        return et("txt-".concat(code));
      }
    },
    value: forgotPasswordFormData.email,
    onChange: function onChange(val) {
      setForgotPasswordFormData(_objectSpread(_objectSpread({}, forgotPasswordFormData), {}, {
        email: val
      }));
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "input-block"
  }, /*#__PURE__*/React.createElement("p", null, gt('login.lbl-forgot-password-account')), /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: '20px'
    }
  }, /*#__PURE__*/React.createElement(Input, {
    id: "forgotPasswordAccount",
    name: "forgotPasswordAccount",
    type: "text",
    placeholder: gt('login.lbl-forgot-password-account'),
    validate: {
      required: true
    },
    value: forgotPasswordFormData.userName,
    onChange: function onChange(val) {
      return setForgotPasswordFormData(_objectSpread(_objectSpread({}, forgotPasswordFormData), {}, {
        userName: val
      }));
    }
  })))), activeModal === ACTIVE_MODAL.FORGOT_PASSWORD_SUCCESS && /*#__PURE__*/React.createElement("div", {
    className: "forgot-password-success"
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '0 0 1rem 0'
    }
  }, gt('login.forgot-password-send-success'))), activeModal === 'login' && /*#__PURE__*/React.createElement("form", {
    ref: form,
    action: "".concat(contextRoot, "/login"),
    method: "post"
  }, /*#__PURE__*/React.createElement("div", {
    className: "input-block"
  }, /*#__PURE__*/React.createElement("p", null, gt('login.lbl-login-account')), /*#__PURE__*/React.createElement("input", {
    ref: loginParam1,
    id: "loginParam1",
    name: "loginParam1",
    type: "text",
    placeholder: gt('login.lbl-login-account'),
    onKeyDown: function onKeyDown(e) {
      return handleKeyDown(e);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "input-block"
  }, /*#__PURE__*/React.createElement("p", null, gt('login.lbl-login-password')), /*#__PURE__*/React.createElement("input", {
    ref: loginParam2,
    id: "loginParam2",
    name: "loginParam2",
    type: "password",
    placeholder: gt('login.lbl-login-password'),
    onKeyDown: function onKeyDown(e) {
      return handleKeyDown(e);
    }
  })), imageCode && /*#__PURE__*/React.createElement("div", {
    className: "imageCodeContainer"
  }, /*#__PURE__*/React.createElement("p", null, gt('login.lbl-image-code')), /*#__PURE__*/React.createElement("input", {
    ref: imageCodeRef,
    id: "imageCode",
    name: "imageCode",
    type: "text",
    placeholder: gt('login.placeholder-image-code'),
    onKeyDown: function onKeyDown(e) {
      return handleKeyDown(e);
    }
  }), /*#__PURE__*/React.createElement("img", {
    className: "imageCode",
    src: imageCode,
    onClick: function onClick() {
      return loadImageCode();
    }
  })))));
};

LoginDialog.defaultProps = {
  id: 'g-login-dialog'
};
LoginDialog.propTypes = {
  id: PropTypes.string
};
export default LoginDialog;